import { render, staticRenderFns } from "./ConsumeRecordsDialog.vue?vue&type=template&id=2b4bff12&scoped=true"
import script from "./ConsumeRecordsDialog.vue?vue&type=script&lang=js"
export * from "./ConsumeRecordsDialog.vue?vue&type=script&lang=js"
import style0 from "./ConsumeRecordsDialog.vue?vue&type=style&index=0&id=2b4bff12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4bff12",
  null
  
)

export default component.exports